import { useQuery } from '@tanstack/react-query';
import { analyticsService } from '../services/analyticsService';

export function useOverview(days = 30) {
  return useQuery({
    queryKey: ['analytics-overview', days],
    queryFn: () => analyticsService.getOverview(days),
    refetchInterval: 60_000, // Refresh every minute
  });
}

export function useConversationVolume(days = 30) {
  return useQuery({
    queryKey: ['analytics-conversation-volume', days],
    queryFn: () => analyticsService.getConversationVolume(days),
  });
}

export function useMessageVolume(days = 30) {
  return useQuery({
    queryKey: ['analytics-message-volume', days],
    queryFn: () => analyticsService.getMessageVolume(days),
  });
}

export function useConversationsByPriority(days = 30) {
  return useQuery({
    queryKey: ['analytics-priority', days],
    queryFn: () => analyticsService.getConversationsByPriority(days),
  });
}

export function useStaffPerformance(days = 30) {
  return useQuery({
    queryKey: ['analytics-staff-performance', days],
    queryFn: () => analyticsService.getStaffPerformance(days),
  });
}

export function useFeedbackSummary(days = 30) {
  return useQuery({
    queryKey: ['analytics-feedback-summary', days],
    queryFn: () => analyticsService.getFeedbackSummary(days),
    refetchInterval: 60_000,
  });
}
